import React, { useEffect } from "react";
import { IconButton, Input, Panel, SelectPicker } from "rsuite";
import Label from "../../../Components/Label";
import TrashIcon from "@rsuite/icons/Trash";
import { userAtom } from "../../../Atoms/user.atom";
import { useRecoilValue } from "recoil";
import Responsive from "../../../Components/Responsive";

const PaidForPanel = ({ info, setModel, data, title, index, onDelete }) => {
  const user = useRecoilValue(userAtom);

  useEffect(() => {
    if (info.clientId && data?.length) {
      const selected = data.find((client) => client.id === info.clientId);
      if (selected) {
        setModel((prev) => {
          const updatedPaidFor = [...prev.users];
          updatedPaidFor[index] = {
            ...updatedPaidFor[index],
            clientId: selected.id || 0,
            fullName: selected.fullName || "",
            email: selected.email || "",
            phone: selected.phone || "",
            passportNumber: selected.passportNumber || "",
            checkoutId: selected.checkoutId || null,
          };
          return { ...prev, users: updatedPaidFor };
        });
      }
    }
  }, [info.clientId, data]);

  const handleChange = (field, value) => {
    setModel((prev) => {
      const updatedPaidFor = [...prev.users];
      updatedPaidFor[index] = {
        ...updatedPaidFor[index],
        [field]: value,
        checkoutId: user.checkoutId,
      };
      return { ...prev, users: updatedPaidFor };
    });
  };

  const handleSelectClient = (value) => {
    const selected = data.find((client) => client.id === value);

    if (selected) {
      setModel((prev) => {
        const updatedPaidFor = [...prev.users];
        updatedPaidFor[index] = {
          clientId: value,
          fullName: selected?.fullName || "",
          email: selected?.email || "",
          phone: selected?.phone || "",
          passportNumber: selected?.passportNumber || "",
          checkoutId: selected.checkoutId,
        };

        return { ...prev, users: updatedPaidFor };
      });
    }
  };

  return (
    <div>
      <Panel
        header={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>{title}</span>
            <IconButton
              onClick={() => onDelete(index)}
              color="violet"
              icon={<TrashIcon />}
              style={{ marginLeft: "10px" }}
            />
          </div>
        }
        bordered
        collapsible
        bodyFill
      >
        <div style={{ background: "#e1e1ff", padding: "12px" }}>
          <Responsive m={12} l={6} xl={6} className="p-5">
            <Label>Recherche:</Label>
            <SelectPicker
              data={[{ label: "Tout", value: 0 }].concat(
                data.map((c) => ({
                  label: c.fullName,
                  value: c.id,
                }))
              )}
              block
              noSearch
              value={info.clientId || 0}
              onSelect={handleSelectClient}
            />
          </Responsive>
          <Responsive m={12} l={6} xl={6} className="p-5">
            <label>Nom Complet:</label>
            <Input
              value={info.fullName || ""}
              onChange={(value) => handleChange("fullName", value)}
              disabled={!!info.clientId}
            />
          </Responsive>
          <Responsive m={12} l={6} xl={6} className="p-5">
            <label>CIN ou Numero du passport:</label>
            <Input
              value={info.passportNumber || ""}
              onChange={(value) => handleChange("passportNumber", value)}
              disabled={!!info.clientId}
            />
          </Responsive>
          <Responsive m={12} l={6} xl={6} className="p-5">
            <label>Téléphone</label>
            <Input
              value={info.phone || ""}
              onChange={(value) => handleChange("phone", value)}
              disabled={!!info.clientId}
            />
          </Responsive>
        </div>
      </Panel>
    </div>
  );
};

export default PaidForPanel;
